import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    addtripModalShow: false,
    addbookingModalShow: false,
};

const mealSlice = createSlice({
    name: 'mealSlice',
    initialState,
    reducers: {
       /* eslint-disable no-param-reassign */


        // Action to show the Add Trip modal
        addTripModalShow(state) {
            state.addtripModalShow = true;
        },
        // Action to hide the Add Trip modal
        addTripModalHide(state) {
            state.addtripModalShow = false;
        },
        // Action to show the Add Booking modal
        addBookingModalShow(state) {
            state.addbookingModalShow = true;
        },
        // Action to hide the Add Booking modal
        addBookingModalHide(state) {
            state.addbookingModalShow = false;
        },
    },
});

// Exporting actions
export const {
    addTripModalShow,
    addTripModalHide,
    addBookingModalShow,
    addBookingModalHide,
} = mealSlice.actions;

// Exporting reducer to be used in the store
export default mealSlice.reducer;
